/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'locales/se': {
    width: 1600,
    height: 1000,
    viewBox: '0 0 16 10',
    data: '<path pid="0" _fill="#006aa7" d="M0 0h16v10H0z"/><path pid="1" _fill="#fecc00" d="M5 0h2v10H5z"/><path pid="2" _fill="#fecc00" d="M0 4h16v2H0z"/>'
  }
})
